module.exports = __webpack_public_path__ + "src/assets/img/page9/5e3fd9d246442cbc337e63148b102eb5.jpg";